export default "__VITE_ASSET__XsOuLhRr__"